import React, { ReactNode } from 'react';
import { AuthProvider, useAuth } from 'react-oidc-context';

// Type declaration for window.env
declare global {
  interface Window {
    env: {
      REACT_APP_OIDC_BASE_URL: string;
      REACT_APP_OIDC_CLIENT_ID: string;
      REACT_APP_REPORT_API_BASE_URL: string;
      REACT_APP_OIDC_AUDIENCE: string;
    };
  }
}

// Use window.env in production, fallback to process.env in development
export const getEnvVar = (key: keyof Window['env']): string => {
  const windowValue = window.env?.[key];

  // If window.env exists but contains placeholder values (e.g., "${REACT_APP_OIDC_BASE_URL}"),
  // it means we're in development and the entrypoint.sh hasn't run to replace them.
  // In this case, fall back to process.env
  if (windowValue && !windowValue.startsWith('${')) {
    return windowValue;
  }

  // Fall back to process.env for development
  return process.env[key] || '';
};

const oidcConfig = {
  authority: getEnvVar('REACT_APP_OIDC_BASE_URL'),
  client_id: getEnvVar('REACT_APP_OIDC_CLIENT_ID'),
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
};

//console.log('OIDC Config:', {
//  authority: getEnvVar('REACT_APP_OIDC_BASE_URL'),
//  client_id: getEnvVar('REACT_APP_OIDC_CLIENT_ID'),
//  redirect_uri: window.location.origin,
//  currentUrl: window.location.href,
//  windowEnv: window.env
//});


interface AuthContextProviderProps {
  children: ReactNode;
}

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
};

// Hook personalizzato per usare l'autenticazione
export const useAuthContext = () => useAuth();
